import React from "react";
import styles from '../styles/exchangeAmount.module.scss'
import SubmitButton from "@/modals/login/submitButton";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import { useTranslation } from "react-i18next";
import Icon from "@/wmCompoments/Icon";

const ExchangeAmount = ({
  exchangeType,            // 当前兑换方向
  balanceData,             // 钱包余额数据
  exchangeRateData,        // 汇率数据
  exchangeAmount,          // 当前输入的兑换金额
  onAmountChange,          // 修改兑换金额函数
  onSubmit,                // 点击兑换的函数
  isLoading,               // 是否正在提交中
}) => {
  
  const { t } = useTranslation('walletExchange')

  // 判断是否从中心钱包兑换(方向)
  const isFromCenter = exchangeType === 0;

  // 当前转出的账户余额
  const fromBalance = isFromCenter ? balanceData?.centerWalletBalance : balanceData?.usdtWalletBalance;
  // 当前转出的账户汇率
  const exchangeRate = isFromCenter ? exchangeRateData?.sellPrice : exchangeRateData?.buyPrice;

  // 错误提示
  const errorText = exchangeAmount > fromBalance ? t('amountTooHigh') : '';

  // 计算实际到账金额
  const actualAmount = exchangeAmount > 0
    ? isFromCenter
      ? (exchangeAmount / exchangeRate).toFixed(2) + ' USDT'
      : (exchangeAmount * exchangeRate).toFixed(2) + ' CNY'
    : '';

  // 币种USDT / CNY 
  const firstCurrency = isFromCenter ? 'CNY' : 'USDT'
  const secondCurrency = isFromCenter ? 'USDT' : 'CNY'

  const firstIcon = isFromCenter ? <Icon name="icon-currency-rmb" className={styles.icon} /> : <Icon name="icon-currency-usdt" className={styles.icon} />
  const secondIcon = isFromCenter ? <Icon name="icon-currency-usdt" className={styles.icon} /> : <Icon name="icon-currency-rmb" className={styles.icon} />

  return (
    <div className={styles.exchangeAmount}>
      <div className={styles.title}>{t('redeemAmount')}</div>

      {/* 错误信息 */}
      {errorText && <div className={styles.error}>{errorText}</div>}

      {/* 兑换 */}
      <div className={styles.content}>
        <div className={styles.input}>
          <input
            type="number"
            value={exchangeAmount == 0 ? '' : exchangeAmount}
            placeholder={isFromCenter ? t('enterRedeemRmb') : t('enterRedeemUsdt')}
            onChange={(e) => onAmountChange(Number(e.target.value))}
          />
          <button onClick={() => onAmountChange(fromBalance ?? 0)}>{t('maxAmount')}</button>
          <div className={styles.currency}>
            {firstIcon}
            <div>{firstCurrency}</div>
          </div>
        </div>

        <div className={styles.output}>
          <div className={styles.received}>{t('actualAmount')}{actualAmount}</div>
          <div className={styles.FXrate}>{t('referenceRate')}{exchangeRate}</div>
          <div className={styles.currency}>
            {secondIcon}
            <div>{secondCurrency}</div>
          </div>
        </div>
      </div>

      {/* 提交按钮 */}
      <SubmitButton
        text={t('redeemNow')}
        // disabled={!!errorText || exchangeAmount <= 0}
        loading={isLoading}
        onClick={onSubmit}
      />
    </div>
  )
}

export default ExchangeAmount